
export const STATUS = {
    PENDING : "Pending",                        // aligned with CxStatusColor
    SUCCESS : "Success",                        // aligned with CxStatusColor
    ERROR   : "Error"                           // aligned with CxStatusColor
};

export const pendingStatus = (info) => {
    return {status: STATUS.PENDING, info: info, date: new Date()}
}

export const successStatus = (info, elapsed=null) => {
    return {status: STATUS.SUCCESS, info: info, date: new Date(), elapsed: elapsed}
}

export const errorStatus = (info, elapsed=null) => {
    return {status: STATUS.ERROR, info: info, date: new Date(), elapsed: elapsed}
}

export const overallStatus = (appStatus) => {
    const statuses = Object.values(appStatus).map(entry => entry.status);
    if (statuses.includes(STATUS.ERROR)) return STATUS.ERROR;
    if (statuses.includes(STATUS.PENDING)) return STATUS.PENDING;
    return STATUS.SUCCESS;
}

export const initialAppStatus = () => {
    return {
        code: pendingStatus("Code data load is pending."),
        crew: pendingStatus("Crew data load is pending."),
        team: pendingStatus("Team data load is pending."),
    }
}


